import { api } from "./api";

export const cardsService = {
  fetch() {
    return api.get("/cards");
  },
};

export default cardsService;
